import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=8037febc&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8037febc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8037febc')) {
      api.createRecord('8037febc', component.options)
    } else {
      api.reload('8037febc', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=8037febc&scoped=true&", function () {
      api.rerender('8037febc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2s2bybKoOlWb5/JS/comp/Accordion.vue"
export default component.exports